module.exports = __webpack_public_path__ + "static/img/strenth.56f235e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/my-coin/strenth.png
// module id = c5e+
// module chunks = 1